/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import {
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
    array,
} from 'prop-types';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { withRouter } from 'react-router';
import { Collapse, Paper } from '@material-ui/core';
import ProductFacetsV3 from './ProductFacetsV3';
import FilterChipsUI from './FilterChipsUI';

const DesktopProductFacetsV3 = ({
    isFoodBrand,
    classes,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    category,
    trackEventAction,
    setFacetsDataInCollection,
    filterDialogData,
    setCheckedOptions,
    checkedOptions,
    openFacetDropdown,
    setFacetLabel,
    resetChecked,
    containerRef,
    selectedFacet,
}) => {
    // use for showing filter based on toggle
    const [toggleFilter, settoggleFilter] = useState(true);
    const expandButton = toggleFilter ? <ExpandLess data-testid="expand-more-icon" /> : <ExpandMore data-testid="expand-less-icon" />;
    const [showCategoryName, setShowCategoryName] = useState(false);
    const handleScroll = () => {
        if (containerRef && containerRef?.current) {
            const { top } = containerRef?.current?.getBoundingClientRect();
            if (top === 0) {
                setShowCategoryName(true);
            } else {
                setShowCategoryName(false);
            }
        }
    };

    useEffect(() => {
        // Add scroll event when the component is loaded
        if (typeof document !== 'undefined') {
            document.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (typeof document !== 'undefined') {
                document.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return (
        <>
            <div className={classes.mainFilterContainerV3}>
                {isFoodBrand && (
                    <div className={classes.filterFacetsV3}>
                        <span data-testid="show-filterData" className={toggleFilter ? `${classes.hideFiltersBg}` : ''} role="presentation" onClick={() => settoggleFilter(!toggleFilter)}>
                            {toggleFilter
                                ? <span className={classes.filterBtnText}>Hide Filters</span>
                                : <span className={classes.filterBtnText}>Filters</span>}
                            {expandButton}
                        </span>
                    </div>
                )}
                {isFoodBrand && (
                    <div className={classes.catNameContainerV3}>
                        {/* first span is empty to leverage space between layout */}
                        <span />
                        {showCategoryName && <span className={classes.filterCategoryNameV3}>{category?.name}</span>}
                        <span className={classes.sortByLabelV3}>Sort By</span>
                    </div>
                )}
                {isFoodBrand && (
                    <div className={classes.breadcrumbAndFilterContainer}>
                        {filterDialogData()}
                    </div>
                )}
            </div>
            {isFoodBrand && toggleFilter && (
                <Collapse in={toggleFilter} className={`${classes.collapsedContainer} ${classes.boxShadowWrapper}`}>
                    <Paper className={classes.filterContainerDialogFoodBox} elevation={4}>
                        {productFacetsBase?.length > 0 && (
                            <ProductFacetsV3
                                category={category}
                                productFacets={productFacetsBase}
                                setFacetsDataInCollection={setFacetsDataInCollection}
                                isFoodBrand={isFoodBrand}
                                isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                                track={trackEventAction}
                                filterOn="Search"
                                setCheckedOptions={setCheckedOptions}
                                checkedOptions={selectedFacet || checkedOptions}
                                openFacetDropdown={openFacetDropdown}
                                setFacetLabel={setFacetLabel}
                            />
                        )}
                    </Paper>
                </Collapse>
            )}

            <FilterChipsUI
                isInModal={false}
                productFacetsBase={productFacetsBase}
                checkedOptions={selectedFacet || checkedOptions}
                setCheckedOptions={setCheckedOptions}
                setFacetsDataInCollection={setFacetsDataInCollection}
                resetChecked={resetChecked}
            />
        </>
    );
};

DesktopProductFacetsV3.propTypes = {
    classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    setFacetsDataInCollection: func.isRequired,
    filterDialogData: func,
    setCheckedOptions: func.isRequired,
    checkedOptions: array.isRequired,
    openFacetDropdown: string.isRequired,
    setFacetLabel: func.isRequired,
    resetChecked: func.isRequired,
    containerRef: shape({
        current: shape({
            top: number,
        }),
    }),
    selectedFacet: array,
};

DesktopProductFacetsV3.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    filterDialogData: () => {},
    containerRef: {},
    selectedFacet: [],
};
export default withRouter(DesktopProductFacetsV3);
